<template>
    <tr>
        <td colspan="6" style="padding: 0px">
            <table class="classificationPlanInnerTable">
                <tbody>
                <tr>

                    <td class="classificationLabelName">({{item.classificationLabel}}) {{ item.classificationLabelName }}</td>
                    <td class="classificationLabel">{{item.classificationLabel}}</td>
                    <td class="rokHrambe">
                        <em v-if="Object.keys(item.rokHrambe).length === 0">{{$t('text.treeItemForPrint.expirationNotSet')}}</em>
                        <table class="table w-100 mb-0" v-if="Object.keys(item.rokHrambe).length > 0">
                            <thead>
                                <tr>
                                    <th class="p-0" style="width: 70px;">{{$t('text.classificationPlanMetadata.expiration')}}</th>
                                    <th class="p-0 text-center" style="width: 70px;">{{$t('text.classificationPlanMetadata.expirationYears')}}</th>
                                    <th class="p-0 text-center" style="width: 70px;">{{$t('text.classificationPlanMetadata.expirationType')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(rokHrambeItem, index) in Object.keys(item.rokHrambe)" :key="index">
                                    <td class="p-0" style="width: 70px;">{{item.rokHrambe[rokHrambeItem].expiration !== '' ? getRokHrambeReadableLabel(item.rokHrambe[rokHrambeItem].expiration) : '/'}}</td>
                                    <td class="p-0 text-center" style="width: 70px;">{{(item.rokHrambe[rokHrambeItem].year !== null && item.rokHrambe[rokHrambeItem].year) ? item.rokHrambe[rokHrambeItem].year : '/'}}</td>
                                    <td class="p-0 text-center" style="width: 70px;">{{item.rokHrambe[rokHrambeItem].expirationType !== null ? getVrstaGradivaReadableLabel(item.rokHrambe[rokHrambeItem].expirationType) : '/'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <td class="povezaniSistemi">
                        <span v-for="povezanSistem, index in item.povezaniSistemi">
                            {{ getConnectedSystemReadableLabel(povezanSistem) }}<span v-if="index != Object.keys(item.povezaniSistemi).length - 1">, </span>
                        </span>
                    </td>
                    <td class="vpisnik">

                        <span v-for="vpisnik, index in item.vpisnik">
                            {{ getRegisterItemReadableLabel(vpisnik) }}<span v-if="index != Object.keys(item.vpisnik).length - 1">, </span>
                        </span>

                    </td>
                    <td class="usageEndDate">{{item.usageEndDate ? moment(item.usageEndDate, "DD/MM/YYYY").format("DD. MM. YYYY") : '/'}}</td>

                </tr>

                <tree-item-for-print
                        class="item"
                        v-for="(item, index) in item.item"
                        :key="index"
                        :item="item"
                        @select-item="$emit('select-item', $event)"
                        :selectedClassLabel="selectedClassLabel"
                        :to-export="toExport"
                        :printMode="true"
                ></tree-item-for-print>

                </tbody>
            </table>
        </td>
    </tr>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'

    library.add(faHome);

    export default {
        name: 'TreeItemForPrint',
        props: {
            item: Object,
            depth: Number,
            selectedClassLabel: String,
            toExport: Boolean,
            move: Boolean,
            printMode: Boolean
        },
        data: function () {
            return {
                vpisniki: [],
                povezaniSistemi: [],
                rokHrambe: [],
                vrstaGradiva: [],

                isOpen: this.item.isOpen,
                movingClass: {},
                keyChanging: 3,
                draggedOver: false,
                checked: true


            }
        },

        watch: {},

        mounted() {

            this.vpisniki = this.$store.getters.getRegisterOptions;
            this.povezaniSistemi = this.$store.getters.getConnectedSystemsOptions;
            this.rokHrambe = this.$store.getters.getStorageDateOptions;
            this.vrstaGradiva = this.$store.getters.getDocumentTypeOptions;

            //this.item = this.getItem(this.item);
            this.$root.$on('move', item => {
                this.setMovingClass(item);
            });


        },

        methods: {

            getRegisterItemReadableLabel(registerId) {
                const _this = this;
                if(_this.vpisniki.length > 0) {
                    return _.filter(_this.vpisniki, { 'id': registerId.toString() })[0].description;
                } else {
                    return registerId
                }
            },

            getConnectedSystemReadableLabel(connectedSystemId) {
                const _this = this;
                if(_this.povezaniSistemi.length > 0) {
                    return _.filter(_this.povezaniSistemi, { 'id': connectedSystemId.toString() })[0].description;
                } else {
                    return connectedSystemId
                }
            },

            getVrstaGradivaReadableLabel(vrstaGradivaId) {



                if( vrstaGradivaId == null){
                    return null;
                }
                else{
                    const _this = this;


                    for(let i = 0; i< this.vrstaGradiva.length; i++){
                        if(this.vrstaGradiva[i].id.toString() === vrstaGradivaId.toString()){
                            return this.vrstaGradiva[i].description;
                        }

                    }

                    return null;
                }

            },

            getRokHrambeReadableLabel(rokHrambeType) {



                if( rokHrambeType == null){
                    return null;
                }
                else{

                    for(let i = 0; i< this.rokHrambe.length; i++){
                        if(this.rokHrambe[i].type.toString() === rokHrambeType.toString()){
                            return this.rokHrambe[i].explanation;
                        }

                    }

                    return null;
                }

            },




            getItem(item) {
                let classificationPlan = this.$store.getters.getClassificationPlanFiltered;
                for (let i = 0; i < classificationPlan.length; i++) {
                    let possibleItem = this.getItemRec(classificationPlan[i], item);
                    if (possibleItem != null) {
                        return possibleItem;
                    }
                }

                return null;
            },

            getItemRec(classificationPlan, item) {
                if (classificationPlan.classificationLabel === item.classificationLabel) {
                    return classificationPlan;
                } else {
                    for (let i = 0; i < classificationPlan.item.length; i++) {
                        let possibleItem = this.getItemRec(classificationPlan.item[i], item);
                        if (possibleItem != null) {
                            return possibleItem;
                        }
                    }
                }

                return null;
            },


            // spremeni checked polje
            // klice se onChange pri checkboxu

            changeThis() {

                this.item = this.getItem(this.item);
                /*
                console.log("change");
                let classificationPlan = this.$store.getters.getClassificationPlan;
                console.log(classificationPlan);
                for(let i = 0; i < classificationPlan.length; i ++) {
                    classificationPlan[i] = this.changeThisRec(classificationPlan[i]);
                }

                this.$store.dispatch("setClassificationPlan", classificationPlan);
                */

                this.$root.$emit('changeThis', this.item);

            },


            // odpiranje/zapiranje otrok
            toggle: function () {
                this.item.structure.isOpen = !this.item.structure.isOpen;
                this.isOpen = !this.isOpen;
                console.log("toggle on: ", this.item.classificationLabel);
            },


            // izbiranje razreda (za urejanje ali deletanje...)
            selectCurrent() {
                this.item.structure.isSelected = !this.item.structure.isSelected;
                this.$emit('select-item', this.item);
            },

            // drag & drop funkcije

            //zacetek draganja
            dragStart: function (ev) {
                this.$root.$emit('move', this.item);
                ev.dataTransfer.setData('text', 'drag');  // nujno za firefox, te date se ne uporablja
            },

            //med draganjem
            drag: function (ev) {
                //console.log("dragging");
            },


            //sprozi premik razreda
            drop: function (ev) {
                console.log("drop");
                ev.preventDefault();
                this.$root.$emit('drop', [this.item, this.movingClass]);
                //this.moveClass(this.item, this.movingClass);
                this.draggedOver = false;


            },


            dragover: function (ev) {
                console.log("dragover");
                ev.preventDefault();
                this.draggedOver = true;


            },

            dragleave: function (ev) {
                ev.preventDefault();
                this.draggedOver = false;

            },

            //shrani podatke o razredu, ki ga premikamo
            setMovingClass(item) {
                console.log(item.classificationLabel);
                this.movingClass = item;
            },


        }
    };
</script>



// WEBPACK FOOTER //
// src/components/TreeItemForPrint.vue